module.exports = __webpack_public_path__ + "img/jacoby.d568a3e3.jpg";